/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { DocumentTemplateCategoryDto } from '../../models/document-template-category-dto';

export interface AdminDocumentTemplateCategoryControllerDeleteDocument$Params {
  id: string;
}

export function adminDocumentTemplateCategoryControllerDeleteDocument(http: HttpClient, rootUrl: string, params: AdminDocumentTemplateCategoryControllerDeleteDocument$Params, context?: HttpContext): Observable<StrictHttpResponse<DocumentTemplateCategoryDto>> {
  const rb = new RequestBuilder(rootUrl, adminDocumentTemplateCategoryControllerDeleteDocument.PATH, 'delete');
  if (params) {
    rb.path('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<DocumentTemplateCategoryDto>;
    })
  );
}

adminDocumentTemplateCategoryControllerDeleteDocument.PATH = '/api/document-template-category-admin/{id}';
